export default "__VITE_ASSET__Hy6nHVfk__"